<div class="public-analytics-page">
  <header class="public-analytics-header">
    <div class="public-analytics-brand">Vertical Talent</div>
    <div class="public-analytics-title">Live Campaign Analytics</div>
    <div class="public-analytics-meta" *ngIf="latestRefresh">
      Last updated {{ latestRefresh | date:'medium' }}
    </div>
  </header>

  <div *ngIf="loading" class="public-analytics-state">Loading…</div>
  <div *ngIf="!loading && error" class="public-analytics-state error">{{ error }}</div>
  <div *ngIf="!loading && !error && videos.length === 0" class="public-analytics-state">
    No live videos have been published for this campaign yet.
  </div>

  <div class="public-analytics-grid" *ngIf="!loading && !error && videos.length > 0">
    <a class="public-video-card" *ngFor="let v of videos" [href]="v.shareUrl || v.url" target="_blank" rel="noopener">
      <div class="public-video-thumb">
        <img *ngIf="v.thumbnailUrl" [src]="v.thumbnailUrl" alt="thumbnail" />
        <div *ngIf="!v.thumbnailUrl" class="public-video-thumb-placeholder">{{ v.platform }}</div>
      </div>
      <div class="public-video-body">
        <div class="public-video-platform">{{ v.platform }}</div>
        <div class="public-video-metrics">
          <div class="public-video-metric"><div class="value">{{ v.views | number }}</div><div class="label">views</div></div>
          <div class="public-video-metric"><div class="value">{{ v.likes | number }}</div><div class="label">likes</div></div>
          <div class="public-video-metric"><div class="value">{{ v.comments | number }}</div><div class="label">comments</div></div>
          <div class="public-video-metric"><div class="value">{{ v.shares | number }}</div><div class="label">shares</div></div>
        </div>
      </div>
    </a>
  </div>
</div>
